import React, { useEffect, useState } from 'react';
import './App.css';
import AppViewer from './components/AppViewer';
import axios from 'axios';
import { socket } from './socket';
import services from './services';

function App() {


    useEffect(() => {
        checkEmailUser();
    }, []);

    const checkEmailUser = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/token/`, {
                headers: {
                    Authorization: `Bearer ${localStorage?.getItem('access_token')}`,
                },
            });
            const findUnAuth = response?.data?.data?.find(({ token_status }) => token_status === 'token is authorized');
            if (findUnAuth?.client_id) {
                updateAuthEmail(findUnAuth.client_id);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const updateAuthEmail = async (client_id) => {
        try {
            await services.email.updateAuthEmail(client_id);
            // You can handle the response if needed
        } catch (error) {
            console.error(error);
        }
    };
const [userRole,setUserRole]=useState()
// useEffect(() => {
//     const messageHandler = (event) => {
//         const getToken = event?.currentTarget?.localStorage
      
//         const { access_token, userData } = getToken;
        
//         setUserRole(JSON.parse(userData));
//         if (access_token) {
//             localStorage.setItem('access_token', access_token);
//         }
        
//         if (event.data.isRemoveItem === true) {
//             localStorage.removeItem('access_token');
//             localStorage.removeItem('userData');
//             localStorage.removeItem('tasks');
//             localStorage.removeItem('board');
//             localStorage.clear();
//         }

//     };

//     window.addEventListener('message', messageHandler);

//     return () => {
//         window.removeEventListener('message', messageHandler);
//     };
// }, []);



    useEffect(() => {
        socket.on('messageSaved', () => { });
        return () => {
            socket.off('messageSaved');
        };
    }, []);




    return (
        <div className="app">
            <AppViewer />
        </div>
    );
}

export default App;
